module.exports = __webpack_public_path__ + "img/ceo_way_adv_01.6be7fb44.png";